import type { ProductResult, SearchResultCommand } from '@/domains/command-center/types'

/**
 * Whether a search result names a product.
 *
 * `resultType` is a plain string and `originalData` is `unknown`, so this is the one place that reads a
 * result as a product. A typo in either would otherwise still compile.
 */
const isProductResult = (result: SearchResultCommand): result is ProductResult => result.resultType === 'product'

export { isProductResult }
